import {FormattedMessage} from 'react-intl'
import Filters, {FilterItem} from 'src/components/templates/Filters/Filters'
import TableHeader from 'src/components/templates/TableHeader/TableHeader'
import TableCustom, {PaginationType, TableColumn} from 'src/components/elements/TableCustom/TableCustom'
import {mdiPlus} from '@mdi/js'
import {Action} from 'src/components/elements/Menus/ActionMenu/ActionsMenu'
import {useAppSelector} from 'src/hooks'

type EnrollmentPatientTableProps = {
  onSubmitFilter: (values: any) => void;
  fetchedData: {data: Record<string, any>[], count: number};
  pagination: PaginationType;
  setPagination:(pagination: PaginationType) => void;
  setIsNewPatientEnrollmentModal: (isOpen: boolean) => void;
  setSelectedRequest: (request?: Record<string, any>) => void;
}

const EnrollmentPatientTable : React.FC<EnrollmentPatientTableProps> = ({
  onSubmitFilter,
  fetchedData,
  pagination,
  setPagination,
  setIsNewPatientEnrollmentModal,
  setSelectedRequest
}) => {
  const pspConfig = useAppSelector(state => state.pspConfigReducer.data)
  const patientEnrollmentColumnOptions = useAppSelector(
    state => state.pspConfigReducer.data.enrollmentHubConfigurations?.patientEnrollmentConfigurations?.columnOptions
  )

  const PATIENT_ENROLLMENT_REQUEST_STATUS_OPTIONS = [
    {value: 'COMPLETED', label: 'Completata'},
    {value: 'WAITING', label: 'In attesa'}
  ]

  const DEFAULT_COLUMNS : TableColumn[] = [
    {
      id: 'lastName',
      label: 'Cognome Paziente'
    },
    {
      id: 'firstName',
      label: 'Nome Paziente'
    },
    {
      id: 'birthDate',
      label: 'Data di nascita',
      type: 'date',
      format: 'ddd DD MMM YYYY'
    },
    {
      id: 'createdAt',
      label: 'Data invio richiesta',
      type: 'date',
      format: 'ddd DD MMM YYYY HH:mm'
    },
    {
      id: 'status',
      label: 'Stato'
    }
  ]

  const columns : TableColumn[] = patientEnrollmentColumnOptions?.length > 0 ?
    patientEnrollmentColumnOptions :
    DEFAULT_COLUMNS

  const filterConfig : FilterItem[] = [
    {
      id: 'lastName',
      label: 'Cognome Paziente',
      type: 'string'
    },
    {
      id: 'firstName',
      label: 'Nome Paziente',
      type: 'string'
    },
    {
      id: 'status',
      label: 'Stato',
      type: 'select',
      options: PATIENT_ENROLLMENT_REQUEST_STATUS_OPTIONS
    }
  ]

  const headerActions : Action[] = [
    {
      id: 'new',
      label: 'Nuova',
      icon: mdiPlus,
      action: () => {
        setSelectedRequest(undefined)
        setIsNewPatientEnrollmentModal(true)
      }
    }
  ]

  const cleanData = (rawData?: Record<string, any>[]) => {
    return (rawData || []).map((row) => ({
      ...row,
      status: PATIENT_ENROLLMENT_REQUEST_STATUS_OPTIONS.find(status => status.value === row?.status)?.label ?? row?.status
    }))
  }

  return (
    <>
      <Filters config={filterConfig} key='filters' onSubmit={onSubmitFilter} />
      <TableHeader actions={headerActions}>
        <div className='table-header'>
          <FormattedMessage id={pspConfig.sidebarItems?.patientEnrollment?.label} />
        </div>
      </TableHeader>
      <TableCustom
        columns={columns}
        onPaginationChange={setPagination}
        pagination={pagination}
        rows={cleanData(fetchedData.data)}
        totalElements={fetchedData.count}
      />
    </>
  )
}

export default EnrollmentPatientTable
